<app-alert-box-component (OnButtonClick)="onAlertButtonClick($event)" (OnAlertClose)="closeAlert($event)"
    (OnAlertVisibility)="alertVisibility($event)" [bShowSecondButton]="bShowSecondAlertButton"
    [alertHeaderText]="alertHeaderText" [alertBodyText]="alertBodyText" [closeButtonText]="alertCloseButtonText"
    [secondButtonText]="alertSecondButtonText" [data]="alertBoxData" [bAlert]="bAlert"></app-alert-box-component>

<c-modal [visible]="bShowResolution" alignment="center" [backdrop]="'static'">
    <form cForm class="row g-2" [formGroup]="resolutionForm" class="needs-validation" novalidate>
        <c-modal-header>
            <h5 cModalTitle>Enter the resolution</h5>
            <button (click)="closeResolutionModal()" cButtonClose></button>
        </c-modal-header>
        <c-modal-body>
            <c-input-group class="mb-3 has-validation">
                <span cInputGroupText>
                    Resolution
                </span>
                <input [valid]="bValidResolution" cFormControl formControlName="resolutionControl" id="RejectReason"
                    type="text" />
                <c-form-feedback [valid]="bValidResolution">{{ifResolutionValid()}}</c-form-feedback>
            </c-input-group>
        </c-modal-body>
        <c-modal-footer>
            <button cButton color="secondary" (click)="closeResolutionModal()">
                Cancel
            </button>
            <!-- <button cButton color="primary" (click)="processResolution()">Update</button> -->
        </c-modal-footer>
    </form>
</c-modal>

<div *ngIf="true">
    <c-navbar expand="lg" class="border-bottom border-bottom-3 border-bottom-primary">
        <c-container fluid>
            <form cForm class="row" [formGroup]="cifSearchForm" (ngSubmit)="getServices()">
                <c-row [gutter]="{gy: 1}">
                    <c-col md="auto">
                        <c-input-group class="has-validation">
                            <span cInputGroupText>
                                Service Type
                            </span>
                            <select cSelect id="serviceType" name="serviceType"
                                formControlName="searchServiceTypeControl" (change)="onSelectChange()">
                                <option selected value="All">All</option>
                                <option *ngFor="let serviceType of serviceTypes" [value]="serviceType.value">
                                    {{serviceType.key}}
                                </option>
                            </select>
                        </c-input-group>
                    </c-col>
                </c-row>
                <c-row [gutter]="{gy: 1}">
                    <c-col lg="5">
                        <c-date-range-picker [startDate]="startDate" [endDate]="endDate"
                            (startDateChange)="onStartDateChane($event)"
                            (endDateChange)="onEndDateChane($event)"></c-date-range-picker>
                    </c-col>
                    <c-col md="auto">
                        <c-input-group class="has-validation">
                            <span cInputGroupText>
                                Ticket Type
                            </span>
                            <select cSelect id="ticketType" name="ticketType" formControlName="searchTicketTypeControl"
                                (change)="onSelectChange()">
                                <option>Open Tickets</option>
                                <option>Closed Tickets</option>
                                <option>All Tickets</option>
                            </select>
                        </c-input-group>
                    </c-col>
                    <c-col md="auto">
                        <button cButton type="submit">
                            Search
                        </button>
                    </c-col>
                </c-row>
            </form>
        </c-container>
    </c-navbar>

    <c-smart-table *ngIf="!showUserForm" [columnSorter]="true" [columns]="columns" [columnFilter]="true"
        [itemsPerPageSelect]="true" [itemsPerPage]="15" [items]="serviceData" [tableBodyProps]="{ align: 'middle' }"
        [tableProps]="{ hover: true, striped: true, responsive: true }" clickableRows header pagination
        (rowClick)="onRowClick($event)">
        <ng-template cTemplateId="tableData" let-columnName="columnName" let-item="item" let-tdContent="tdContent">
            <td>
                <ng-container [ngSwitch]="columnName">
                    <ng-container *ngSwitchCase="'requestedOn'">
                        {{(getDisplayDate(item))}}
                    </ng-container>
                    <ng-container *ngSwitchCase="'resolvedOn'">
                        {{(getResolutionDate(item))}}
                    </ng-container>
                    <ng-container *ngSwitchCase="'isOpen'">
                        <c-badge [color]="getStatusBadge(item)">
                            {{(getStatus(item))}}
                        </c-badge>
                    </ng-container>
                    <ng-container *ngSwitchCase="'action'">
                        <button cButton size="sm" *ngIf="showResolveButton(item)"
                            (click)="showResolutionModal(item); $event.stopPropagation();">
                            {{'Update'}}
                        </button>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        {{tdContent}}
                    </ng-container>
                </ng-container>
            </td>
        </ng-template>
    </c-smart-table>

    <div *ngIf="showUserForm" style="margin-top:20px;background-color: #fff;padding: 32px;">
        <div class="section-title">Request Details</div>

        <form cForm [formGroup]="userForm" class="needs-validation" [gutter]="3" novalidate>
            <div class="row">
                <div class="col-6">
                    <label cLabel for="inputRequestId">Request ID</label>
                    <input readonly cFormControl id="inputRequestId" type="text" formControlName="requestId" />
                </div>
                <div class="col-6">
                    <label cLabel for="ddlStatus">Status</label>
                    <select cSelect id="ddlStatus" name="status" formControlName="status">
                        <option value="Open">Open</option>
                        <option value="Resolved">Resolved</option>
                    </select>
                </div> 
            </div>
            <div class="row">
                <div class="col-6">
                    <label cLabel for="inputCIF">CIF</label>
                    <input cFormControl id="inputCIF" type="text" formControlName="customerCIF" />
                </div>
                <div class="col-6">
                    <label cLabel for="inputName">Full Name</label>
                    <input cFormControl id="inputName" type="text" formControlName="customerName" />
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <label cLabel for="inputEmail">Email</label>
                    <input cFormControl id="inputEmail" type="email" formControlName="customerEmail" />
                </div>
                <div class="col-6">
                    <label cLabel for="inputMobileNumber">Mobile Number</label>
                    <input cFormControl id="inputMobileNumber" type="tel" formControlName="customerMobile" />
                </div>
            </div>            
            <div class="row"> 
                <div class="col-6">
                    <label cLabel for="inputRequestType">Request Type</label>
                    <input readonly cFormControl id="inputRequestType" type="text" formControlName="requestType" />
                </div>
                <div class="col-6">
                    <label cLabel for="ddlClientCategory">Client Category</label>
                    <select cSelect id="ddlClientCategory" name="clientCategory" formControlName="clientCategory">
                        <option value="">Select</option>
                        <option value="RETAIL.CLIENT">Retail Client</option>
                        <option value="PROFESSIONAL.CLIENT">Professional Client</option>
                    </select>
                </div>                
            </div>
            <div class="row pt-2">
                <div class="col-12">
                    <label cLabel for="inputCustomerRemarks">Customer Remarks</label>
                    <textarea readonly cFormControl id="inputRemarks" rows="2" formControlName="CustomerRemarks"></textarea>
                </div>
            </div>            
            <div class="row pt-2">
                <div class="col-12">
                    <label cLabel for="inputInternalRemarks">Internal Remarks</label>
                    <textarea cFormControl id="inputInternalRemarks" rows="2" formControlName="internalRemarks"></textarea>
                </div>
            </div>
            <div class="row pt-2">
                <div class="col-12">
                    <label cLabel for="inputResolutionGiven">Resolution Given</label>
                    <textarea cFormControl id="inputResolutionGiven" rows="2"
                        formControlName="resolutionGiven"></textarea>
                </div>
            </div>
            <div class="row pt-2">
                <div class="col-12">
                    <div cFormCheck>
                        <input cFormCheckInput id="sendRemarksToCustomer" type="checkbox" formControlName="sendRemarksToCustomer" />
                        <label cFormCheckLabel for="sendRemarksToCustomer">Send these Remarks to Customer</label>
                    </div>
                </div>
            </div>
 


            

            <div class="row pt-2" *ngIf="documents.length">
                <div class="section-title">Documents</div>
                <div class="col-4" *ngFor="let doc of documents">
                    <button (click)="downloadDocument(doc)" class="btn btn-default w-100 mb-2">
                        {{ doc.documentName }}
                    </button>
                </div>
            </div>

            <div class="row" style="margin-top: 32px;padding-bottom:32px;">
                <div class="col-6 d-flex gap-24">
                    <button cButton color="light" size="lg" type="button" (click)="resetForm()">
                        Back
                    </button>
                    <button cButton color="primary" size="lg" type="button"
                        *ngIf="selectedItem && !isRequestResolved()"
                        [disabled]="!canUpdateForm()"
                        (click)="onUpdateClick()">
                        Update
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>